import { Button, Tooltip } from "@mui/material";
import React, { useState } from "react";
import styles from "styles/component/RightList.module.scss";
import { useDispatch } from "react-redux";
import { setSelectedGroup } from "redux/MapSlice";
import { useSelectedGroup } from "hooks/MapDetails";
import eventEmitter from "services/event.emitter";
import events from "json/events";
import {
  setEnableMoveMode,
} from "redux/CourseMapSlice";
import asset from "json/assets";

export default function CourseMapOptionList(props) {
  const {
    index,
    icon,
    title,
    onClickEvent = () => {},
    tooltipText,
    isMapControlListPanelHidden,
    setMapControlListPanelHidden
  } = props;
  const dispatch = useDispatch();
  const selectedGroup = useSelectedGroup();
  const [anchorEl, setAnchorEl] = useState(null);
  const openAnchor = selectedGroup === title && Boolean(anchorEl);
  
  const handleClick = (e) => {
    setMapControlListPanelHidden(false);
    eventEmitter.emit(events.openMapElementInfoModal, { 
      visible: true,
      title: title,
      mCoord: {
        x: e.target.getBoundingClientRect()?.x,
        y: e.target.getBoundingClientRect()?.y
      } 
    });

    eventEmitter.emit("resetMoveMode");
    dispatch(setEnableMoveMode(false));
    onClickEvent();
    setAnchorEl(e.currentTarget);
    dispatch(setSelectedGroup(title));
    eventEmitter.emit(events.addMarkerToggle, { visible: false });
    eventEmitter.emit(events.disableDraw);
  };

  return (
    <div className={styles.buttonContainer}>
      <Tooltip title={tooltipText} arrow placement="left">
        <Button
          onClick={handleClick}
          aria-describedby={index}
          className={`${openAnchor ? `${styles.active_btn} ${isMapControlListPanelHidden ? `${styles.normalized_borders}` : ""}` : ""}`}
        >
          <span className={styles.icon}>
            <img src={icon} alt="" />
          </span>
        </Button>
      </Tooltip>
      
      {openAnchor && isMapControlListPanelHidden && (
        <div 
          className={styles.arrowIcon}
          onClick={handleClick}
        >
          <img src={asset.right_arrow_white} alt="arrow" />
        </div>
      )}
    </div>
  );
}